import { z } from "zod";

export const GoToFoodSchema = z.object({
  selectedMeals: z
    .array(
      z.object({
        name: z.string().min(1, "Meal name cannot be empty"),
      }),
    )
    .min(1, "Please add at least one meal")
    .max(3, "Maximum 20 meals allowed"),
});

export type GoToFoodFormData = z.infer<typeof GoToFoodSchema>;
